<div class="form-group">
  <label for="prod-m">{{ 'map.label.point'| translate }}</label>
  <angular2-multiselect [data]="pointsList"
      [(ngModel)]="pointSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onPointSelect()">
  </angular2-multiselect>
</div>